export class Conf {
    public static API_URL = 'https://hanoigo.org/api';
    public static URL = 'https://hanoigo.org/';
    public static providers = {
        'google': {
            'clientId': '374339478332-5uqlqgtned8cf8b0dn80pur5ct0o16f4.apps.googleusercontent.com'
        },
        'facebook': {
            'clientId': '150133295733096',
            'apiVersion': 'v2.10'
        }
    };
    public static google_api_key = "AIzaSyCTvzEXRThLKoHt9Y3I4Kl2TLrJXOCOe90";
}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/settings/config.ts